<script setup lang="ts">
import {
  computed,
} from 'vue';
import {
  useRoute,
  useRouter,
} from 'vue-router';

import VCard from '@components/card/VCard/VCard.vue';
import { TRANSLATION_GROUP_AFF_BALANCES } from '@modules/aff-balances/constants';
import {
  ADMIN_BALANCES_LIST_ROUTE_NAME,
  BALANCES_LIST_QUERY_KEY,
  BALANCES_PERMISSIONS,
} from '@modules/balances/constants';
import { BALANCES_ITEM_QUERY_KEY } from '@modules/balances/submodules/edit/constants';
import { useBalancesItemQuery } from '@modules/balances/submodules/edit/queries';
import PaymentSystemWithdrawalForm from '@modules/payment-systems/components/PaymentSystemWithdrawalForm/PaymentSystemWithdrawalForm.vue';
import { useQueryClient } from '@tanstack/vue-query';
import { isString } from '@utils/guards';

const route = useRoute();
const router = useRouter();
const queryClient = useQueryClient();
const id = computed<number>(() => (
  isString(route.params.id) ? Number(route.params.id) : 0
));

const { data: balancesItem } = useBalancesItemQuery(id);

const balance = computed(() => balancesItem.value?.amount);

function onSubmit(): void {
  void queryClient.invalidateQueries({ queryKey: [BALANCES_LIST_QUERY_KEY] });
  router.back({
    name: ADMIN_BALANCES_LIST_ROUTE_NAME,
  });
  void queryClient.resetQueries({ queryKey: [BALANCES_ITEM_QUERY_KEY] });
}
</script>

<template>
  <VCard v-data-qa-auto-id="'BalancesWithdrawalPage'"
    type="form"
    :title="$getTranslation(TRANSLATION_GROUP_AFF_BALANCES, 'WITHDRAWAL_HEADER')"
  >
    <PaymentSystemWithdrawalForm
      is-select-button
      :aff-id="id"
      :balance="balance"
      query-type="cashout"
      :permission="BALANCES_PERMISSIONS.EDIT"
      :back-route="{
        name: ADMIN_BALANCES_LIST_ROUTE_NAME,
      }"
      @submit="onSubmit"
    />
  </VCard>
</template>
